import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { updateCustomerSettings } from '../../../common/api/clients/companySettings.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { translate } from '../../../common/helpers/translate.helper';

export const useCustomerSettingsEdit = () => {
    const queryClient = useQueryClient();
    const { addErrorToast } = useToasts();

    return useMutation({
        mutationFn: updateCustomerSettings,
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: queries.customers.detail(variables.id)._ctx.settings.queryKey });
        },
        onError: () => {
            addErrorToast(translate('company.toasts.informationUpdateError'));
        },
    });
};
